import { Validator } from ".";

export class CustomValidator<TData> extends Validator<TData> {

    private _validFunc: (data: TData) => string | undefined;
    public constructor(validFunc: (data: TData) => string | undefined) {
        super();
        this._validFunc = validFunc;
    }

    public validate(data: TData): boolean {
        const result = this._validFunc(data);

        if (result === undefined) {
            this.clearErrors();
            return true;
        }

        this.setError(result);
        return false;
    }
}
